import { blue } from "@ant-design/colors";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { PiBuildingsBold } from "react-icons/pi";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@lib/constants";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { ApiParams } from "@lib/types";
import { useQuery } from "@tanstack/react-query";
import { apiGetAIWalletAddress } from "@lib/api/walletAI";

type Props = {
  cardProps?: AppCardProps;
  params?: ApiParams;
};

export default function AIWhiteLabelMiniCard(props: Props) {
  const {
    cardProps,
    params = {
      filter: [`customerId||$notnull`],
    },
  } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();

  const query = useQuery({
    queryFn: () => apiGetAIWalletAddress(params),
    queryKey: ["ai-white-label-minicard", JSON.stringify(params)],
    enabled: !!params,
  });
  const { data, isLoading } = query;
  const apiData = data?.data?.data || [];
  const total = apiData.length;

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.CUSTOMER.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <PiBuildingsBold />,
        color: blue[5],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.aiCustomer"] as string }}
          />
        ),
        title: total,
      }}
    />
  );
}
